var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHidePassword = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M2 9s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 2.5,
  stroke: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "m3 3 12 12"
})));
export default SvgHidePassword;